import React, { Component } from 'react';
import { Link } from "react-router-dom";
// import { Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";

//i18n
import { Icon } from '@iconify/react/dist/iconify.js';
import { Breadcrumbs, Grid, Stack } from '@mui/material';
import { withTranslation } from "react-i18next";

class Breadcrumb extends Component {
    render() {
        const itemsLength = this.props.breadcrumbItems.length;
        return (
            <React.Fragment>
                <Grid container className='page-title-box' id="page-topbar-header-word-breadcrumb" spacing={2} mb={2}>
                    <Grid item xs={12} display={'flex'} alignItems={'center'}>
                        {this.props.showBackButton && (
                            <span
                                style={{
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    marginRight: '12px',
                                    color: '#5f6368',
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '30%',
                                    border: '1px solid #e0e0e0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#ffffff',
                                    transition: 'background-color 0.2s',
                                    position: 'relative',
                                    top: '10px',
                                }}
                                onClick={() => window.history.back()}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                            >
                                <i className="ri-arrow-left-line" style={{ color: '#7D7D7D' }}></i>
                            </span>
                        )}
                        <Breadcrumbs listClassName="mx-2 m-0" className='header d-flex' style={{ margin: "18px 18px 0px 0px" }} maxItems={2}>
                            {
                                this.props.breadcrumbItems.map((item, key) => {
                                    const isLast = key + 1 === itemsLength;
                                    const truncateSx = {
                                        fontSize: "14px",
                                        display: "inline-block",
                                        maxWidth: { lg: 400, md: 200, sm: 200, xs: 150 },           // adjust max width as needed
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        verticalAlign: "middle",
                                        fontFamily: isLast ? 'SophiaPro-Medium' : 'SophiaPro',
                                        color: '#191919'
                                    };

                                    return isLast ? (
                                        <Stack key={key} sx={truncateSx} title={this.props.t(item.title)} alignItems={"center"}>
                                            {item.icon ? <Icon icon={item.icon} style={{ marginRight: "8px", fontSize: "18px" }} /> : null} 
                                            <span style={{fontWeight: "550px", fontSize: "18px", color: '#101010'}}>{this.props.t(item.title)}</span>
                                        </Stack>
                                    ) : (
                                        <Link key={key} to={item.link} style={{ textDecoration: 'none' }} alignItems={"center"}>
                                            <Stack sx={truncateSx} title={this.props.t(item.title)}>
                                                {item.icon ? <Icon icon={item.icon} style={{ marginRight: "8px", fontSize: "18px" }} /> : null}
                                            <span style={{fontWeight: "550px", fontSize: "18px", color: '#808588'}}>{this.props.t(item.title)}</span>
                                            </Stack>
                                        </Link>
                                    );
                                })
                            }
                        </Breadcrumbs>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default withTranslation()(Breadcrumb);